import { render, staticRenderFns } from "./Clpt.vue?vue&type=template&id=36db2186&lang=true"
import script from "./Clpt.vue?vue&type=script&lang=js"
export * from "./Clpt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports